import { aboutNestedRoutes } from "./about-nested-routes";
import { industryNestedRoutes } from "./industry-nested-routes";

export const navbarData = [
  {
    id: 1,
    name: "Home",
    path: "/",
  },
  {
    id: 6,
    name: "About",
    path: "/about/overview",
    nestedRoutes: [...aboutNestedRoutes],
    hasDropDown: true,
  },
  {
    id: 7,
    name: "Industries",
    path: "/about/board-of-directors",
    nestedRoutes: [...industryNestedRoutes],
    hasDropDown: true,
  },
  {
    id: 2,
    name: "Our works",
    path: "/where-we-work",
  },
  {
    id: 3,
    name: "Solution",
    path: "/solutions",
  },
  {
    id: 4,
    name: "Partners",
    path: "/partners",
  },
  {
    id: 5,
    name: "Sustainability",
    path: "/sustainability",
  },
];
